module.exports = __webpack_public_path__ + "img/soundfield_2.41d2314c.jpg";